import { setBrowserMode } from '@/reducers/menus';
import { getUrlParams } from '@/libs/utils/url-parse';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

// 隐藏导航栏的路由前缀
const HIDE_NAV_ROUTES = /^\/(teachingBlock|share|p)(\/|$)/;
const NAVBAR_HEIGHT = '64px';

// 山西定制版页面状态判断
const useHideNav = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const browserMode = useSelector((state) => state.menus.browserMode);

  const isHideNav = useMemo(() => {
    if (HIDE_NAV_ROUTES.test(location.pathname)) {
      return true;
    }

    const mode = getUrlParams('mode');
    if (mode === 'simple') {
      return true;
    }
    if (mode !== null) {
      return false;
    }

    return browserMode === 'simple';
  }, [location.pathname, location.search, browserMode]);

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--navber-height',
      isHideNav ? '0px' : NAVBAR_HEIGHT,
    );
  }, [isHideNav]);

  useEffect(() => {
    const mode = getUrlParams('mode');
    if (mode === 'simple' && browserMode !== 'simple') {
      dispatch(setBrowserMode('simple'));
    } else if (mode && mode !== 'simple' && browserMode !== '') {
      dispatch(setBrowserMode(''));
    }
  }, [dispatch, browserMode, location.search]);

  return { isHideNav };
};

export default useHideNav;
